/**
 * Citation HTML is a closed set of emphasis tags (plan fixtures + citeproc
 * HTML mode). User-supplied CSL fields must never become real tags at the
 * React / clipboard sinks.
 *
 * Matches the SSR example allowlist in show.html.slim (i/b/sup) plus the
 * extra emphasis tags citeproc may emit. Attributes are always stripped.
 */
const ALLOWED_TAGS = new Set([
  'i',
  'b',
  'em',
  'strong',
  'sup',
  'sub',
  'span',
  'br',
]);

export function escapeHtmlText(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeBareAngles(s: string): string {
  return s.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function normalizeAllowedTag(raw: string, name: string): string {
  if (name === 'br') {
    return raw.startsWith('</') ? '' : '<br>';
  }
  return raw.startsWith('</') ? `</${name}>` : `<${name}>`;
}

export function sanitizeCitationHtml(html: string): string {
  const withoutComments = html.replace(/<!--[\s\S]*?-->/g, '');
  const tagRe = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g;
  const parts: string[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null = tagRe.exec(withoutComments);
  while (match !== null) {
    parts.push(escapeBareAngles(withoutComments.slice(lastIndex, match.index)));
    const name = match[1].toLowerCase();
    if (ALLOWED_TAGS.has(name)) {
      parts.push(normalizeAllowedTag(match[0], name));
    } else {
      parts.push(escapeBareAngles(match[0]));
    }
    lastIndex = match.index + match[0].length;
    match = tagRe.exec(withoutComments);
  }
  parts.push(escapeBareAngles(withoutComments.slice(lastIndex)));
  return parts.join('');
}
